
import React from 'react';
import ReactCrop, { Crop, PixelCrop } from 'react-image-crop';
import { useTouchZoom } from './useTouchZoom';
import 'react-image-crop/dist/ReactCrop.css';

interface CropperCanvasProps {
  imageSrc: string;
  crop: Crop;
  zoom: number;
  setZoom: (zoom: number) => void;
  setCrop: (crop: Crop) => void;
  setCompletedCrop: (crop: PixelCrop) => void;
  onImageLoad: (img: HTMLImageElement) => void;
  imgRef: React.RefObject<HTMLImageElement>;
}

const CropperCanvas = ({
  imageSrc,
  crop,
  zoom,
  setZoom,
  setCrop,
  setCompletedCrop,
  onImageLoad,
  imgRef
}: CropperCanvasProps) => {
  const { handleTouchStart, handleTouchMove, handleTouchEnd } = useTouchZoom({
    zoom,
    setZoom,
    minZoom: 0.5,
    maxZoom: 3
  });

  return (
    <div 
      className="relative max-h-96 overflow-hidden rounded-lg border-2 border-pink-200 touch-none"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <ReactCrop
        crop={crop}
        onChange={(_, percentCrop) => setCrop(percentCrop)}
        onComplete={(c) => setCompletedCrop(c)}
        aspect={1}
        locked={true}
        circularCrop={false}
        ruleOfThirds
        className="max-w-full"
      >
        <img
          ref={imgRef}
          src={imageSrc}
          alt="Crop preview"
          onLoad={(e) => onImageLoad(e.currentTarget)}
          className="max-w-full max-h-96 object-contain"
          style={{
            transform: `scale(${zoom})`,
            transformOrigin: 'center center',
            transition: 'transform 0.1s ease-out'
          }}
        />
      </ReactCrop>
    </div>
  );
};

export default CropperCanvas;
